import React from 'react';

function AgreementUserField({ value, maxLength, data }) {
  if (!value) return <>-</>;

  if (maxLength && typeof value === 'string' && value.length > maxLength) {
    return <>{value.substr(0, maxLength)}...</>;
  }

  return (
    <>
      {data.condoId
        ? `Condominio`
        : data.profile?.type === 'SUPPLIER'
        ? `Fornitore`
        : data.profile?.type === 'CERTIFIER'
        ? `Certificatore`
        : data.profile?.type === 'AGENCY'
        ? `Agenzia`
        : [
            'BUILDING_ADMIN_1',
            'BUILDING_ADMIN_2',
            'BUILDING_ADMIN_3',
            'BUILDING_ADMIN_4',
            'BUILDING_ADMIN_5',
          ].includes(data.profile?.type)
        ? 'Amministratore'
        : '-'}
    </>
  );
}

export default AgreementUserField;
